import * as React from 'react';
import { DataTypeProvider, DataTypeProviderProps } from '@devexpress/dx-react-grid';

const NumberTypeProvider = (props: DataTypeProviderProps) => <DataTypeProvider {...props} />;

export { NumberTypeProvider };
